import { Modal } from 'bootstrap';

let hcaptchaWidgetId = null;
let hcaptchaScriptLoading = null;

function loadHcaptchaScript() {
    if (window.hcaptcha) {
        return Promise.resolve();
    }

    if (hcaptchaScriptLoading) {
        return hcaptchaScriptLoading;
    }

    hcaptchaScriptLoading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://js.hcaptcha.com/1/api.js?render=explicit&hl=ru';
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Не удалось загрузить hCaptcha'));
        document.head.appendChild(script);
    });

    return hcaptchaScriptLoading;
}

function showHcaptchaError(message) {
    const errorEl = document.getElementById('consultationHcaptchaError');
    if (!errorEl) {
        return;
    }
    errorEl.textContent = message;
    errorEl.classList.remove('d-none');
}

function clearHcaptchaError() {
    const errorEl = document.getElementById('consultationHcaptchaError');
    if (!errorEl) {
        return;
    }
    errorEl.textContent = '';
    errorEl.classList.add('d-none');
}

function ensureHcaptchaWidget() {
    const container = document.getElementById('consultationHcaptcha');
    if (!container || !window.hcaptcha || !container.dataset.sitekey) {
        return;
    }

    if (hcaptchaWidgetId !== null) {
        window.hcaptcha.reset(hcaptchaWidgetId);
        return;
    }

    hcaptchaWidgetId = window.hcaptcha.render(container, {
        sitekey: container.dataset.sitekey,
        callback: onConsultationHcaptchaSuccess,
        'expired-callback': onConsultationHcaptchaExpired,
        'error-callback': onConsultationHcaptchaError,
    });
}

function openHcaptchaModal() {
    const modalEl = document.getElementById('modalHcaptcha');
    if (!modalEl) {
        return;
    }

    clearHcaptchaError();

    const renderWhenShown = () => {
        ensureHcaptchaWidget();
    };

    modalEl.removeEventListener('shown.bs.modal', renderWhenShown);
    modalEl.addEventListener('shown.bs.modal', renderWhenShown, { once: true });

    loadHcaptchaScript()
        .then(() => {
            const modal = Modal.getOrCreateInstance(modalEl);
            modal.show();
        })
        .catch(() => {
            showHcaptchaError('Не удалось загрузить проверку. Обновите страницу и попробуйте снова.');
            const modal = Modal.getOrCreateInstance(modalEl);
            modal.show();
        });
}

function closeHcaptchaModal() {
    const modalEl = document.getElementById('modalHcaptcha');
    if (!modalEl) {
        return;
    }
    const modal = Modal.getInstance(modalEl);
    if (modal) {
        modal.hide();
    }
    if (window.hcaptcha && hcaptchaWidgetId !== null) {
        window.hcaptcha.reset(hcaptchaWidgetId);
    }
}

function setCaptchaToken(token) {
    const form = document.getElementById('consultationForm');
    if (!form) {
        return;
    }

    let input = form.querySelector('input[name="h-captcha-response"]');
    if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'h-captcha-response';
        form.appendChild(input);
    }
    input.value = token || '';
}

function applyPartialUpdates(payload) {
    if (!payload || typeof payload !== 'object') {
        return;
    }

    Object.keys(payload).forEach((key) => {
        if (!key.startsWith('#')) {
            return;
        }
        const target = document.querySelector(key);
        if (target) {
            target.innerHTML = payload[key];
        }
    });
}

function getXsrfToken() {
    const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
}

function handleSubmitSuccess() {
    closeHcaptchaModal();
    setCaptchaToken('');
    const form = document.getElementById('consultationForm');
    if (form) {
        form.reset();
    }
}

function handleSubmitError() {
    if (window.hcaptcha && hcaptchaWidgetId !== null) {
        window.hcaptcha.reset(hcaptchaWidgetId);
    }
    setCaptchaToken('');
    showHcaptchaError('Не удалось отправить заявку. Пройдите проверку ещё раз.');
}

function submitViaWinterRequest(form) {
    return new Promise((resolve, reject) => {
        window.jQuery(form).request('questionsForm::onFormSubmit', {
            success: function (data) {
                this.success(data);
                resolve(data);
            },
            error: function (jqXHR) {
                this.error(jqXHR);
                reject(jqXHR);
            },
        });
    });
}

function submitViaFetch(form) {
    const headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'X-WINTER-REQUEST-HANDLER': 'questionsForm::onFormSubmit',
        'X-WINTER-REQUEST-PARTIALS': '',
    };

    const xsrf = getXsrfToken();
    if (xsrf) {
        headers['X-XSRF-TOKEN'] = xsrf;
    }

    return fetch(window.location.href.split('#')[0], {
        method: 'POST',
        headers,
        body: new FormData(form),
        credentials: 'same-origin',
    }).then(async (response) => {
        let payload = null;
        try {
            payload = await response.json();
        } catch (e) {
            payload = null;
        }

        applyPartialUpdates(payload);

        if (response.status === 406) {
            throw new Error('ajax-exception');
        }

        if (!response.ok) {
            throw new Error('http-' + response.status);
        }

        return payload;
    });
}

function submitConsultationForm() {
    const form = document.getElementById('consultationForm');
    if (!form) {
        return;
    }

    const canUseJqueryRequest =
        window.jQuery &&
        window.jQuery.fn &&
        typeof window.jQuery.fn.request === 'function';

    const submitPromise = canUseJqueryRequest
        ? submitViaWinterRequest(form)
        : submitViaFetch(form);

    submitPromise.then(handleSubmitSuccess).catch(handleSubmitError);
}

function onConsultationHcaptchaSuccess(token) {
    clearHcaptchaError();
    setCaptchaToken(token);
    submitConsultationForm();
}

function onConsultationHcaptchaExpired() {
    setCaptchaToken('');
    showHcaptchaError('Проверка истекла. Пройдите её ещё раз.');
}

function onConsultationHcaptchaError() {
    setCaptchaToken('');
    showHcaptchaError('Ошибка проверки. Обновите страницу и попробуйте снова.');
}

window.onConsultationHcaptchaSuccess = onConsultationHcaptchaSuccess;
window.onConsultationHcaptchaExpired = onConsultationHcaptchaExpired;
window.onConsultationHcaptchaError = onConsultationHcaptchaError;

export function initConsultationHcaptcha() {
    const form = document.getElementById('consultationForm');
    if (!form) {
        return;
    }

    form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        openHcaptchaModal();
    });
}
